<template>
  <v-card>
    <v-card-title>
      <span>{{title}}</span>
    </v-card-title>
    <v-card-text>
    <p>Change all participants to: </p>
    <div v-for="field in fields" :key="field.data">
      <v-text-field 
      :label="field.data" 
      v-if="field.type == 'text'" 
      v-on:blur="changed[field.data] = field" 
      v-model="field.value">
      </v-text-field>
      <v-autocomplete 
        v-if="field.type == 'select'"
        v-model="field.value"
        :items="field.options"
        :label="field.data"
        v-on:blur="changed[field.data] = field" 
      ></v-autocomplete>
      <!-- <DateTimeField
        v-if="field.type == 'date'" 
        :label="field.data"  
        :object="field" 
        objectKey="value"
        :initialValue="''"
      ></DateTimeField>
      <DateTimeField
        v-if="field.type == 'time'" 
        :label="field.data" 
        :object="field"
        objectKey="value" 
        type="time" 
        :initialValue="''"
      ></DateTimeField> -->
    </div>
    <v-spacer></v-spacer>
    <p class="text-right mb-2">
      <v-btn text color="error" @click="$emit('close')">Cancel</v-btn>
      <v-btn text color="primary" @click="save">Save</v-btn>
    </p>
    </v-card-text>  
  </v-card>
</template>

<script>

// import DateTimeField from "../../components/tools/DateTimeField.vue";
export default {
  name: 'MultiEdit',
  components: {
    // DateTimeField
  },
  props: {
    selected: {type: Array, default: () => [] },
    fields: {type: Array, default: () => [] },
    title: { type: String, default: () => "Multi Edit" }
  },
  data: () => {
    return {
      changed: {}
    }
  },
  methods: {
    save: function(){
      const self = this;
      for( var key in self.changed ){
        self.$emit("change", self.changed[key])
      }
      self.$emit("close")
    }
  }
};
</script>
